module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/eat-drinks/EATDRINKS_01-season.png";